import { Check, ChevronLeft, Loader2 } from "lucide-react";

export const wInput =
  "w-full rounded-2xl border border-line bg-white px-4 py-4 text-base text-slate-900 placeholder-zinc-400 outline-none transition-colors focus:border-blaze sm:text-sm";

export const wLabel = "mb-2 block text-[11px] font-bold uppercase tracking-[0.2em] text-slate-500";

export const StepTitle = ({ title, sub }) => (
  <div className="mb-5">
    <h2 className="font-display text-lg font-semibold uppercase tracking-tight text-slate-900 sm:text-2xl">{title}</h2>
    {sub && <p className="mt-1 text-xs leading-relaxed text-slate-500 sm:text-sm">{sub}</p>}
  </div>
);

export const SelectCard = ({ icon: Icon, label, sub, active, onClick, testid }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testid}
    className={`relative flex items-center gap-3 rounded-2xl border-2 p-4 text-left transition-all duration-200 active:scale-[0.98] ${
      active ? "border-blaze bg-blaze/[0.06] shadow-[0_8px_24px_rgba(37,99,235,0.12)]" : "border-line bg-white hover:border-blaze/50"
    }`}
  >
    {Icon && <Icon className={`h-6 w-6 shrink-0 ${active ? "text-blaze" : "text-slate-400"}`} strokeWidth={1.8} />}
    <span className="min-w-0">
      <span className={`block text-sm font-bold ${active ? "text-blaze" : "text-slate-800"}`}>{label}</span>
      {sub && <span className="block truncate text-xs text-slate-500">{sub}</span>}
    </span>
    {active && <Check className="ml-auto h-5 w-5 shrink-0 text-blaze" strokeWidth={3} />}
  </button>
);

export const Pill = ({ label, active, onClick, testid }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testid}
    className={`rounded-full border-2 px-4 py-2.5 text-sm font-semibold transition-all duration-200 active:scale-95 ${
      active ? "border-blaze bg-blaze text-white" : "border-line bg-white text-slate-700 hover:border-blaze/50"
    }`}
  >
    {label}
  </button>
);

export const NavRow = ({ onBack, onNext, nextLabel = "Continue", loading = false, testid = "wz-next" }) => (
  <div className="mt-8 flex flex-col gap-3">
    <button
      type="button"
      onClick={onNext}
      disabled={loading}
      data-testid={testid}
      className="flex w-full items-center justify-center gap-2 rounded-2xl bg-blaze py-4 text-sm font-bold uppercase tracking-widest text-white transition-all duration-200 hover:bg-blue-700 active:scale-[0.98] disabled:opacity-60"
    >
      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : nextLabel}
    </button>
    {onBack && (
      <button
        type="button"
        onClick={onBack}
        data-testid="wz-back"
        className="flex w-full items-center justify-center gap-1.5 py-2 text-xs font-bold uppercase tracking-widest text-slate-400 transition-colors hover:text-slate-700"
      >
        <ChevronLeft className="h-4 w-4" /> Back
      </button>
    )}
  </div>
);
